import React from "react";
import PropTypes from "prop-types";
import { Typography, Switch } from "antd";
import DetailsHeaderWrapper from "./DetailsHeader.style";
import { FormattedMessage } from "react-intl";
import RestrictedComponent from "../util/RestrictedComponent";
const { Title } = Typography;

const DetailsHeader = (props) => {
  const {
    hasSwitch,
    mode,
    isActive,
    onActivate,
    editTitle,
    addTitle,
    resource,
    action,
    hideStatus,
    noRestrictions,
  } = props;
  return (
    <DetailsHeaderWrapper>
      <Title level={5} style={{ margin: 0 }}>
        {mode === "edit" ? editTitle : addTitle}
      </Title>
      {hasSwitch ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {hideStatus ? null : (
            <p style={{ padding: "0 10px", margin: 0 }}>
              {isActive ? (
                <FormattedMessage id="app.forms.active" />
              ) : (
                <FormattedMessage id="app.forms.frozen" />
              )}
            </p>
          )}
          {noRestrictions ? (
            <div>
              {onActivate != null && (
                <Switch checked={isActive} onChange={onActivate} />
              )}
            </div>
          ) : (
            <RestrictedComponent
              resource={resource}
              action={action}
              comp={null}
            >
              {onActivate != null && (
                <Switch checked={isActive} onChange={onActivate} />
              )}
            </RestrictedComponent>
          )}
        </div>
      ) : null}
    </DetailsHeaderWrapper>
  );
};

DetailsHeader.propTypes = {
  mode: PropTypes.string,
  isActive: PropTypes.bool,
  hasSwitch: PropTypes.bool,
  onActivate: PropTypes.func,
  editTitle: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  addTitle: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default DetailsHeader;
